// extracted by mini-css-extract-plugin
module.exports = {"info":"GoalSeek-module_info_22QES","expand":"GoalSeek-module_expand_1tKue"};